import { render, staticRenderFns } from "./PIDTaoTutorial.vue?vue&type=template&id=ec6d081c&scoped=true"
import script from "./PIDTaoTutorial.vue?vue&type=script&lang=js"
export * from "./PIDTaoTutorial.vue?vue&type=script&lang=js"
import style0 from "./PIDTaoTutorial.vue?vue&type=style&index=0&id=ec6d081c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec6d081c",
  null
  
)

export default component.exports